var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "NtcSectorMapping"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('fieldset', [_c('legend', [_vm._v("NTC Sector Mapping")]), _vm._v(" "), _c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingUpload
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingUpload = $event
      }
    }
  }), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onUploadSubmit($event)
      }
    }
  }, [_c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Upload NTC Sector Mapping File")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-file'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('configFile')
    },
    attrs: {
      "type": "file",
      "placeholder": "Upload File",
      "name": "configFile",
      "id": "configFile",
      "accept": ".csv,.zip"
    }
  })]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("Note: * Only .csv or .zip files allowed. Max size 5 MB.")])], 1), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('configFile')),
      expression: "errors.has('configFile')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Upload file is required.")])], 1), _vm._v(" "), (_vm.failed.length > 0) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Download Failed Rows")]), _vm._v(" "), _c('b-input-group', {
    staticStyle: {
      "height": "45px"
    },
    attrs: {
      "left": "<i class='fa fa-file-text'></i>"
    }
  }, [_c('span', {
    staticClass: "form-control",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "Download failed NTC Sector Mapping rows"
    },
    on: {
      "click": _vm.exportFailedConfig
    }
  }, [_c('span', {
    staticClass: "form-control",
    staticStyle: {
      "border": "0"
    }
  }, [_vm._v("\n                      Download\n                      "), _c('i', {
    staticClass: "fa fa-download",
    staticStyle: {
      "margin-left": "10px",
      "font-size": "18px",
      "color": "red"
    }
  })])])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Download NTC Sector Mapping File")]), _vm._v(" "), _c('b-input-group', {
    staticStyle: {
      "height": "45px"
    },
    attrs: {
      "left": "<i class='fa fa-file-text'></i>"
    }
  }, [_c('span', {
    staticClass: "form-control",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "Download OD mappings for your hub — Mot prefilled per row"
    },
    on: {
      "click": function($event) {
        return _vm.downloadNTCFile()
      }
    }
  }, [_c('span', {
    staticClass: "form-control",
    staticStyle: {
      "border": "0"
    }
  }, [_vm._v("\n                      All routes\n                      "), _c('i', {
    staticClass: "fa fa-download",
    staticStyle: {
      "margin-left": "10px",
      "font-size": "18px",
      "color": "#20a8d8"
    }
  })])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "expected-column"
  }, [_c('div', {
    staticClass: "expected-title"
  }, [_vm._v("Expected columns:")]), _vm._v(" "), _c('div', {
    staticClass: "column-tags"
  }, _vm._l((_vm.uploadColumns), function(col) {
    return _c('span', {
      key: col.key,
      class: ['column-tag', col.required !== false ? 'mandatory' : 'optional'],
      attrs: {
        "title": col.required !== false ? 'Required column' : 'Optional column'
      }
    }, [_vm._v("\n                      " + _vm._s(col.header) + "\n                      "), (col.required === false) ? _c('em', {
      staticClass: "optional-hint"
    }, [_vm._v("(optional)")]) : _vm._e()])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "layout-note"
  }, [_vm._v("\n                    Download the CSV template, fill in the sector columns, then upload the completed\n                    .csv or a .zip containing the file. Column headers must match exactly (case-sensitive).\n                  ")])])])]), _vm._v(" "), (_vm.lastUploadSummary) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "upload-summary"
  }, [_c('div', {
    staticClass: "upload-summary-title"
  }, [_vm._v("Last upload summary")]), _vm._v(" "), _c('div', {
    staticClass: "upload-summary-body"
  }, [(_vm.lastUploadSummary.totalRows != null) ? _c('span', {
    staticClass: "upload-summary-chip total"
  }, [_vm._v("\n                      Total rows: "), _c('strong', [_vm._v(_vm._s(_vm.lastUploadSummary.totalRows))])]) : _vm._e(), _vm._v(" "), (_vm.lastUploadSummary.validCount != null) ? _c('span', {
    staticClass: "upload-summary-chip valid"
  }, [_vm._v("\n                      Valid: "), _c('strong', [_vm._v(_vm._s(_vm.lastUploadSummary.validCount))])]) : _vm._e(), _vm._v(" "), (_vm.lastUploadSummary.insertedCount != null) ? _c('span', {
    staticClass: "upload-summary-chip inserted"
  }, [_vm._v("\n                      New inserted: "), _c('strong', [_vm._v(_vm._s(_vm.lastUploadSummary.insertedCount))])]) : _vm._e(), _vm._v(" "), (_vm.lastUploadSummary.updatedCount != null) ? _c('span', {
    staticClass: "upload-summary-chip updated"
  }, [_vm._v("\n                      Existing updated: "), _c('strong', [_vm._v(_vm._s(_vm.lastUploadSummary.updatedCount))])]) : _vm._e()])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "common-success btn btn-secondary",
    attrs: {
      "type": "submit",
      "title": "Upload NTC Sector Mapping file"
    }
  }, [_c('i', {
    staticClass: "fa fa-upload"
  }), _vm._v(" Upload\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "common-danger btn btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_vm._v("Reset")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "search-table"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse1",
      modifiers: {
        "collapse1": true
      }
    }],
    staticClass: "fa fa-filter filter",
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": "false"
    }
  }, [_vm._v(" Filter")])]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "id": "collapse1"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('h5', {
    staticClass: "text-primary"
  }, [_vm._v("Search NTC Sector Mappings")]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isSearching
    },
    on: {
      "update:active": function($event) {
        _vm.isSearching = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_vm._l((_vm.searchFilterConfig), function(filter) {
    return _c('div', {
      key: filter.field,
      staticClass: "col-md-4 mb-2"
    }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(filter.label))]), _vm._v(" "), _c('b-input-group', {
      attrs: {
        "left": filter.icon
      }
    }, [_c('basic-select', {
      staticClass: "form-control",
      attrs: {
        "options": filter.options,
        "selected-option": _vm.searchItems[filter.field],
        "name": filter.field,
        "placeholder": 'Select ' + filter.label
      },
      on: {
        "select": function($event) {
          return _vm.selectSearchFilter(filter.field, $event)
        }
      }
    })], 1)], 1)], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 mb-2 d-flex align-items-end"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.applySearch
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search\n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-secondary",
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetSearch
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Reset\n                    ")])])], 2)], 1)])], 1), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "layout-note"
  }, [_vm._v("\n                    All active rows are shown here.\n            ")]), _vm._v(" "), _c('div', {
    style: (_vm.rows.length > 8 ? 'overflow:auto; height: 420px;' : 'overflow:auto;')
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bag Origin")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Scan Location")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Destination")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("NTC")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Secondary NTC")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Zone")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Business Type")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("MOT")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bag Type")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Routing Cluster")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Primary Sector")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Secondary Sector")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.rows), function(row, index) {
    return _c('tr', {
      key: row.sectorId || index
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.pageno * _vm.limit + index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(row.bagOriginHubName))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(row.scanLocationHubName))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(row.destinationHubName))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(row.ntcHubName))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(row.secondaryNtcHubName || '—'))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(row.zone))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(row.businessType))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(row.mot))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(row.bagType))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(row.routingCluster))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(row.primarySectorName))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(row.secondarySectorName))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "btn btn-sm btn-primary",
      attrs: {
        "title": "Edit Routing Cluster / Primary Sector / Secondary Sector / Toggle Active"
      },
      on: {
        "click": function($event) {
          return _vm.openEditRow(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })])])])
  }), _vm._v(" "), (_vm.rows.length < 1) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "15"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)])]), _vm._v(" "), _c('paginate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalRows > _vm.limit),
      expression: "totalRows > limit"
    }],
    attrs: {
      "page-count": _vm.pageCount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1)], 1)], 1)], 1)]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "editNtcSectorMappingModal",
      "size": "lg",
      "centered": "",
      "hide-footer": "",
      "hide-header": "",
      "body-class": "p-0",
      "title": "Edit NTC Sector Mapping"
    },
    model: {
      value: (_vm.isEditModalShow),
      callback: function($$v) {
        _vm.isEditModalShow = $$v
      },
      expression: "isEditModalShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content sector-edit-modal"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Edit NTC Sector Mapping")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeEditModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm sector-edit-body"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isSavingEdit
    },
    on: {
      "update:active": function($event) {
        _vm.isSavingEdit = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sector-edit-section"
  }, [_c('h6', {
    staticClass: "sector-edit-section-title"
  }, [_vm._v("Mapping Details")]), _vm._v(" "), _c('div', {
    staticClass: "row sector-edit-grid"
  }, [_c('div', {
    staticClass: "col-md-4 sector-edit-field"
  }, [_c('label', {
    staticClass: "sector-edit-label"
  }, [_vm._v("Bag Origin")]), _vm._v(" "), _c('input', {
    staticClass: "form-control sector-edit-input sector-edit-input--readonly",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.editForm.bagOrigin
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 sector-edit-field"
  }, [_c('label', {
    staticClass: "sector-edit-label"
  }, [_vm._v("Scan Location")]), _vm._v(" "), _c('input', {
    staticClass: "form-control sector-edit-input sector-edit-input--readonly",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.editForm.scanLocation
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 sector-edit-field"
  }, [_c('label', {
    staticClass: "sector-edit-label"
  }, [_vm._v("Destination")]), _vm._v(" "), _c('input', {
    staticClass: "form-control sector-edit-input sector-edit-input--readonly",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.editForm.destination
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 sector-edit-field"
  }, [_c('label', {
    staticClass: "sector-edit-label"
  }, [_vm._v("NTC")]), _vm._v(" "), _c('input', {
    staticClass: "form-control sector-edit-input sector-edit-input--readonly",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.editForm.ntc
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 sector-edit-field"
  }, [_c('label', {
    staticClass: "sector-edit-label"
  }, [_vm._v("Secondary NTC")]), _vm._v(" "), _c('input', {
    staticClass: "form-control sector-edit-input sector-edit-input--readonly",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.editForm.secondaryNtc || '—'
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 sector-edit-field"
  }, [_c('label', {
    staticClass: "sector-edit-label"
  }, [_vm._v("Zone")]), _vm._v(" "), _c('input', {
    staticClass: "form-control sector-edit-input sector-edit-input--readonly",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.editForm.zone
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 sector-edit-field"
  }, [_c('label', {
    staticClass: "sector-edit-label"
  }, [_vm._v("Business Type")]), _vm._v(" "), _c('input', {
    staticClass: "form-control sector-edit-input sector-edit-input--readonly",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.editForm.businessType
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 sector-edit-field"
  }, [_c('label', {
    staticClass: "sector-edit-label"
  }, [_vm._v("MOT")]), _vm._v(" "), _c('input', {
    staticClass: "form-control sector-edit-input sector-edit-input--readonly",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.editForm.mot
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 sector-edit-field"
  }, [_c('label', {
    staticClass: "sector-edit-label"
  }, [_vm._v("Bag Type")]), _vm._v(" "), _c('input', {
    staticClass: "form-control sector-edit-input sector-edit-input--readonly",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.editForm.bagType
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "sector-edit-section sector-edit-section--editable"
  }, [_c('h6', {
    staticClass: "sector-edit-section-title"
  }, [_vm._v("Editable Fields")]), _vm._v(" "), _c('div', {
    staticClass: "row sector-edit-grid"
  }, [_c('div', {
    staticClass: "col-md-4 sector-edit-field"
  }, [_c('label', {
    staticClass: "sector-edit-label"
  }, [_vm._v("Routing Cluster")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editForm.routingCluster),
      expression: "editForm.routingCluster"
    }],
    staticClass: "form-control sector-edit-input",
    attrs: {
      "type": "text",
      "placeholder": "Routing Cluster"
    },
    domProps: {
      "value": (_vm.editForm.routingCluster)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editForm, "routingCluster", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 sector-edit-field"
  }, [_c('label', {
    staticClass: "sector-edit-label"
  }, [_vm._v("Primary Sector")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editForm.primarySector),
      expression: "editForm.primarySector"
    }],
    staticClass: "form-control sector-edit-input",
    attrs: {
      "type": "text",
      "placeholder": "Primary Sector"
    },
    domProps: {
      "value": (_vm.editForm.primarySector)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editForm, "primarySector", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 sector-edit-field"
  }, [_c('label', {
    staticClass: "sector-edit-label"
  }, [_vm._v("Secondary Sector")]), _vm._v(" "), _c('div', {
    staticClass: "secondary-sector-picker"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editForm.secondarySector),
      expression: "editForm.secondarySector"
    }],
    staticClass: "form-control sector-edit-input",
    attrs: {
      "type": "text",
      "placeholder": "Secondary Sector"
    },
    domProps: {
      "value": (_vm.editForm.secondarySector)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editForm, "secondarySector", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.editForm.secondarySector) ? _c('button', {
    staticClass: "btn btn-link btn-sm secondary-sector-clear",
    attrs: {
      "type": "button",
      "title": "Clear Secondary Sector — submitting after clearing will remove it from this row."
    },
    on: {
      "click": _vm.clearEditSecondarySector
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  }), _vm._v(" Clear\n                  ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 sector-edit-field"
  }, [_c('label', {
    staticClass: "sector-edit-label"
  }, [_vm._v("Active")]), _vm._v(" "), _c('div', {
    staticClass: "sector-edit-checkbox"
  }, [_c('b-form-checkbox', {
    attrs: {
      "name": "editIsActive"
    },
    model: {
      value: (_vm.editForm.isActive),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "isActive", $$v)
      },
      expression: "editForm.isActive"
    }
  }, [_vm._v("\n                    Active\n                  ")])], 1)])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm sector-edit-footer"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isSavingEdit
    },
    on: {
      "click": _vm.submitEdit
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Save\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeEditModal
    }
  }, [_vm._v("\n            Cancel\n          ")])])])])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02125cc8","hasScoped":true}!./src/views/components/NtcSectorMapping/NtcSectorMapping.html
// module id = 2079
// module chunks = 2